import { useQuery } from '@tanstack/react-query';

import { getVenueAdCampaignConfiguration } from 'apis/ad-bookings/api';

import { CampaignsQueryKeys } from '../../campaignsQueryKeys';
import { transformVenueAdCampaignConfig } from '../utils/transformAdCampaignApiToAdCampaignForm';

const ONE_HOUR = 1000 * 60 * 60;

export const useAdCampaignVenueConfiguration = ({
  venueId,
  country,
  enabled,
  retry = true,
}: {
  venueId: string | undefined;
  country: Country | undefined;
  enabled: boolean;
  retry?: boolean;
}) => {
  const hasValidParams = !!venueId && !!country;

  return useQuery({
    queryKey: CampaignsQueryKeys.ADS.VENUES.GET_CAMPAIGN_CONFIG({ venueId, country }),
    queryFn: () =>
      hasValidParams
        ? getVenueAdCampaignConfiguration(venueId, country)
        : Promise.reject(new Error('venue and country are required')),
    refetchOnWindowFocus: false,
    retry,
    enabled: enabled && !!venueId && !!country,
    select: data => transformVenueAdCampaignConfig(data),
    cacheTime: ONE_HOUR,
    staleTime: ONE_HOUR,
  });
};
